module.exports = __webpack_public_path__ + "img/2@2x (1).ae50543e.png";